export default __webpack_public_path__ + "static/media/100_40554.fd9ca090.jpg";